import React, { Component } from 'react';
import Badge from './../Badge/Badge';
import PropTypes from 'prop-types';
import FooterBar from './components/FooterBar/FooterBar';
import style from './style/sectionblock.scss'; // eslint-disable-line

/**
 * Report section block
 *
 * @example
 * <SectionBlock
 *     root={{ root: ''}}
 * />
 */
export default class SectionBlock extends Component {
    render() {
        const { children, classes } = this.props;

        return (
            <div className={ `${style.scoreBlock} ${classes.root ? classes.root : ''}` }>
                <div className={ `${style.contentWrapper} ${classes.contentWrapper ? classes.contentWrapper : ''}` }>
                    { classes.badge && classes.badge.figure
                        ? <Badge classes={ classes.badge } />
                        : null
                    }
                    { children }
                </div>
            </div>
        );
    }
}

SectionBlock.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
        contentWrapper: PropTypes.string,
        badge: PropTypes.object
    })
};

SectionBlock.defaultProps = {
    classes: {
        root: '',
        contentWrapper: '',
        badge: {
            root: '',
            figure: ''
        }
    }
};
